angular.
module('MyApp')
  .service('PagamentosService', ['$resource', '$q', 'SessionData', 'Configs', function ($resource, $q, SessionData, Configs) {


    this.listarPagamentos = function (codPessoa, id_projeto) {
      let deferr = $q.defer();
      if (codPessoa && id_projeto) {
        $resource(Configs.getApiServer() + '/edital/pagamentos?cod-pessoa=:codPessoa&id-projeto=:id_projeto',
          {}, { 'query': { method: 'GET', isArray: true } }).query({
            codPessoa, id_projeto
          }, function (response) {
            deferr.resolve(response);

          }, function () {
            deferr.reject();
          });
      } else {
        deferr.resolve(false);
      }
      return deferr.promise;
    }

    this.obterConfiguracoesPagamentoExterno = function (params) {
      let defer = $q.defer();

      $resource(Configs.getApiServer() + '/pgtoexterno/config', {}, {
        query: {
          method: 'POST',
          isArray: true
        }
      })
        .query(params, function (result) {
          defer.resolve(result);
        }, function (err) {
          defer.reject(err);
        });

      return defer.promise;
    }

    this.criaPedidoPagamentoExterno = function (params) {
      let defer = $q.defer();

      $resource(Configs.getApiServer() + '/pgtoexterno/pedido-pgto-externo-token', {}, {
        query: {
          method: 'POST'
        }
      })
        .query(params, function (result) {
          defer.resolve(result);
        }, function (err) {
          defer.reject(err);
        });

      return defer.promise;
    }

    this.atualizarPedidoPagamentoExterno = function (params) {
      let defer = $q.defer();

      $resource(Configs.getApiServer() + '/pgtoexterno/atualizar-pedido-pgto-externo', {}, {
        query: {
          method: 'POST'
        }
      })
        .query(params, function (result) {
          defer.resolve(result);
        }, function (err) {
          defer.reject(err);
        });

      return defer.promise;
    }

  }]);
